import { Box, Button, Input, Text } from "@chakra-ui/react";
import Select from "react-select";
import { useDropdownOptions } from "../../hooks/useDropdownOptions";

const CaseSearchForm = ({
  handleSubmit,
  onSubmit,
  register,
  setValue,
  isLoading,
}) => {
  const { options: caseTypeOptions } = useDropdownOptions("CASE_TYPE");

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box w="100%">
        <Text mb={1}>First Name</Text>
        <Input
          type="text"
          placeholder="First name"
          focusBorderColor="bgColor"
          {...register("FIRST_NAME")}
        />
      </Box>
      <Box w="100%">
        <Text mb={1}>Last Name</Text>
        <Input
          placeholder="Last name"
          focusBorderColor="bgColor"
          {...register("LAST_NAME")}
        />
      </Box>

      <Box w="100%">
        <Text mb={1}>Case ID</Text>
        <Input
          placeholder="Case ID"
          focusBorderColor="bgColor"
          {...register("id")}
        />
      </Box>

      <Box w="100%">
        <Text mb={1}>Gender</Text>
        <Select
          styles={{ container: (base) => ({ ...base, width: "100%" }) }}
          options={[
            { value: "M", label: "Male" },
            { value: "F", label: "Female" },
          ]}
          placeholder="Select Gender"
          onChange={(selectedOption) =>
            setValue("GENDER", selectedOption?.value)
          }
        />
      </Box>

      <Box mb={2}>
        <Text mb={1}>Event Date</Text>
        <Input
          type="date"
          focusBorderColor="bgColor"
          {...register("EVENT_DATE")}
        />
      </Box>

      <Box mb={2}>
        <Text mb={1}>Date Of Birth</Text>
        <Input
          type="date"
          focusBorderColor="bgColor"
          {...register("BIRTH_DATE")}
        />
      </Box>

      <Box mb={5} w="100%">
        <Text mb={1}>Type</Text>
        <Select
          options={caseTypeOptions}
          placeholder="Search & Select Type"
          isSearchable
          styles={{ container: (base) => ({ ...base, width: "100%" }) }}
          onChange={(selectedOption) => setValue("Type", selectedOption?.value)}
          noOptionsMessage={() => "No match found"}
        />
      </Box>
      <Button
        type="submit"
        isDisabled={isLoading}
        variant="primaryButton"
        mt={2}
        w="full"
        _hover={{ bg: "bgColor" }}
      >
        {isLoading ? "Searching..." : "Search"}
      </Button>
    </form>
  );
};

export default CaseSearchForm;
